import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Stepper } from '../../components/UI';
import Paso1Cliente    from './Paso1Cliente';
import Paso2Servicios  from './Paso2Servicios';
import PasoCrear        from './PasoCrear';

export default function NuevaOrden() {
  const location = useLocation();
  const preseleccion = location.state || {};

  const [paso, setPaso] = useState(preseleccion.clientePreseleccionado ? 2 : 1);
  const [datos, setDatos] = useState({
    cliente: preseleccion.clientePreseleccionado || null,
    vehiculo: preseleccion.vehiculoPreseleccionado || null,
    kilometraje: '',
    paquetes: [],
  });

  const merge = (cambios) => setDatos(d => ({ ...d, ...cambios }));

  return (
    <div className="page-content">
      <h1 className="page-title">Nueva orden de trabajo</h1>
      <p style={{ color: 'var(--gris-4)', fontSize: '.875rem', marginBottom: '1.25rem', marginTop: '-.5rem' }}>
        Se crea como borrador para imprimir antes del trabajo. El kilometraje, escaneo y batería se completan al cerrarla, cuando el cliente venga a buscar el vehículo.
      </p>
      <Stepper actual={paso} total={3} labels={['Cliente', 'Servicios', 'Crear']} />

      {paso === 1 && (
        <Paso1Cliente datos={datos} onChange={merge}
          onSiguiente={() => setPaso(2)} requiereKm={false} />
      )}
      {paso === 2 && (
        <Paso2Servicios datos={datos} onChange={merge}
          onSiguiente={() => setPaso(3)} onAnterior={() => setPaso(1)} />
      )}
      {paso === 3 && (
        <PasoCrear datos={datos} onAnterior={() => setPaso(2)} />
      )}
    </div>
  );
}
